module.exports = __webpack_public_path__ + "img/star.df4e93b7.png";